import React, { useContext } from "react";
import { Heading, LinkButton, Subheading } from "../../atoms";
import { ArrowRight } from "../../icons";
import { LinkContext } from "../../../context";
import { twMerge } from "../../../utils";
export var EventsGridCard = function(param) {
    var label = param.label, pretitle = param.pretitle, title = param.title, callToAction = param.callToAction, className = param.className, _withBorder = param.withBorder, withBorder = _withBorder === void 0 ? true : _withBorder;
    var LinkComponent = useContext(LinkContext).LinkComponent;
    var ref;
    return /*#__PURE__*/ React.createElement("article", {
        className: className
    }, /*#__PURE__*/ React.createElement(LinkComponent, {
        href: (ref = callToAction === null || callToAction === void 0 ? void 0 : callToAction.href) !== null && ref !== void 0 ? ref : "/",
        download: callToAction === null || callToAction === void 0 ? void 0 : callToAction.download,
        target: callToAction === null || callToAction === void 0 ? void 0 : callToAction.target,
        className: twMerge("block border-fg-default/30 px-5 py-6 md:px-6 md:py-7", withBorder && "border-l")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: "text-fg-default mb-6"
    }, label), !!pretitle && /*#__PURE__*/ React.createElement(Heading, {
        variant: "h3s",
        className: "text-brand-primary-base"
    }, pretitle), /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3s"
    }, title), !!callToAction && /*#__PURE__*/ React.createElement("div", {
        className: "mt-auto pt-9 flex"
    }, /*#__PURE__*/ React.createElement(LinkButton, {
        as: "button",
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
        className: ""
    }, callToAction.label)))));
};

//# sourceMappingURL=EventsGridCard.js.map